import { Skeleton } from "@/components/ui/skeleton";

const TodosTabSkeleton = () => (
  <div className="space-y-6">
    <div className="flex justify-between items-center">
      <div className="flex flex-col gap-1.5 items-start">
        <Skeleton className="h-[30px] w-[200px]" />
        <Skeleton className="h-[20px] w-[290px]" />
      </div>

      <div className="flex gap-2">
        <Skeleton className="h-10 w-[105px]" />
        <Skeleton className="h-10 w-[140px]" />
      </div>
    </div>

    <div className="mt-6 flex justify-between items-center">
      <Skeleton className="h-10 w-[130px]" />

      <div className="flex gap-2">
        <Skeleton className="h-10 w-[140px]" />
        <Skeleton className="h-10 w-[60px]" />
      </div>
    </div>

    <div className="grid grid-cols-1 lg:grid-cols-4 gap-4 flex-1 min-h-0 overflow-hidden h-full">
      {[...Array(4)].map((_, i) => (
        <div
          className="flex flex-col h-[633px] max-h-full overflow-auto space-y-3 transition-all duration-200 border rounded-lg p-4"
          key={i}
        >
          <div className="flex items-center justify-between">
            <div className="flex flex-col gap-2">
              <Skeleton className="h-7 w-16" />
              <Skeleton className="h-5 w-20" />
            </div>

            <Skeleton className="h-[22px] w-[28px] rounded-xl" />
          </div>

          <Skeleton className="h-8 w-full" />

          {[...Array(4)].map((_, i) => (
            <Skeleton key={`column-${i}`} className="h-[103px] w-full" />
          ))}
        </div>
      ))}
    </div>
  </div>
);

export default TodosTabSkeleton;
